<template>
  <div>
    <div
      class="course-item"
      :class="{ 'is-lock-wrap': !CourseItemData.isAvailable }"
      @click="showDialog"
    >
      <div class="course-item-left">
        <div class="number-title">第{{ CourseItemData.index  }}节</div>
        <div class="icon-wrap">
          <div class="lock-icon" v-if="!CourseItemData.isAvailable"></div>
          <div
            class="play-icon"
            :class="{ 'play-unlock': CourseItemData.isAvailable }"
          ></div>
        </div>
      </div>
      <div class="course-item-content">
        <div class="course-item-title">{{ CourseItemData.title }}</div>
        <div class="course-item-desc">
          <div class="duration">
            <img src="./images/duration.png" />
            {{ formatDuration(CourseItemData.duration) }}
          </div>
          <div class="time">
            {{ dayjs(CourseItemData.updateTime).format('MM.DD') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import dayjs from 'dayjs'
import api from '../../api/api'
import { openurl } from '@em/ym'
export default {
  name: 'CourseItem',
  props: ['CourseItemData', 'couponNo', 'productId'],
  data() {
    return {
      lookTime: 0,
      currentBag: this.$store.getters.getCurrentBag
    }
  },
  methods: {
    dayjs,
    showDialog() {
      const item = this.CourseItemData
      if (item.isAvailable) {
        // 有权限就不用再调用了
        Dialog.alert({
          message: `已有权限，无需解锁`,
          confirmButtonColor: '#046bcc'
        })
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `解锁课程《${item.title}》【第${item.index}节】。确定吗？`,
        confirmButtonColor: '#046bcc',
        cancelButtonColor: '#999'
      }).then(() => {
        this.creteUnlockOrder()
      })
    },
    formatDuration(seconds) {
      seconds = Math.max(0, seconds) // 确保秒数不为负
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = seconds % 60

      const formatted = [
        h > 0 ? h : null, // 只有小时大于 0 才显示
        m.toString().padStart(2, '0'), // 补 0
        s.toString().padStart(2, '0') // 补 0
      ].filter(Boolean) // 过滤掉 null

      return formatted.join(':')
    },

    async creteUnlockOrder() {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      const item = this.CourseItemData
      const couponNo = this.$route.query.couponNo
      const { detail, result } = await api.course.creteCouponOrder({
        productId: this.productId,
        subProductId: item.courseId,
        couponNo: this.couponNo || couponNo
      })
      if (result.code === 0) {
        const orderId = detail
        this.getExchangeResult(orderId)
      }
    },

    async getExchangeResult(orderId) {
      console.info('orderId', orderId)
      const { detail, result } = await api.course.getExchangeResult({
        orderId: orderId
      })
      if (result.code === 0 && detail.success) {
        console.info('detail', detail)
        this.$set(this.CourseItemData, 'isAvailable', true)
        // 手动清除 Toast
        Toast.clear()

        Dialog.alert({
          message: `解锁成功！`,
          confirmButtonColor: '#046bcc',
          confirmButtonText: '去查看',
          className: 'unlock-success'
        }).then(() => {
          openurl(this.currentBag.courseUri)
        })
      } else {
        this.lookTime++
        if (this.lookTime < 5) {
          setTimeout(() => {
            this.getExchangeResult(orderId)
          }, 1000)
        } else {
          // 手动清除 Toast
          Toast.clear()
          Dialog.alert({
            message: `${detail.message}`,
            confirmButtonColor: '#046bcc',
            confirmButtonText: '确定'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.course-item {
  display: flex;
  padding: 20px 10px;
  border-radius: 8px;
  background: rgba(245, 245, 245, 1);
  margin-bottom: 20px;
  &.is-lock-wrap {
    .number-title {
      color: rgba(0, 0, 0, 0.5);
    }
    .course-item-title {
      color: rgba(0, 0, 0, 0.5);
      font-weight: 400;
    }
    .course-item-desc {
      .duration {
        color: rgba(0, 0, 0, 0.5);
      }
      .time {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .course-item-left {
    padding-right: 20px;
    border-right: 1px dashed rgba(180, 180, 180, 1);
  }
  .number-title {
    font-size: 32px;
    font-weight: 700;
    color: rgba(0, 0, 0, 1);
  }
  .icon-wrap {
    display: flex;
    items-align: center;
    margin-top: 20px;
    .lock-icon {
      width: 46px;
      height: 46px;
      background: url(./images/lock-icon.png) no-repeat;
      background-size: 100% 100%;
      margin-right: 10px;
    }
    .play-icon {
      width: 46px;
      height: 46px;
      background: url(./images/play-lock.png) no-repeat;
      background-size: 100% 100%;

      &.play-unlock {
        background: url(./images/play-unlock.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .course-item-img {
    position: relative;
    width: 200px;
    height: 112px;
    border-radius: 4px;
    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba(0, 0, 0, 0.25);
      color: #ffffff;
      font-size: 24px;
      padding: 0 10px;
      border-radius: 4px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 4px;
    }
  }
  .course-item-content {
    flex: 1;
    padding: 0 10px;
    margin-left: 20px;
  }
  .course-item-title {
    font-size: 32px;
    color: rgba(50, 50, 50, 1);
    margin-bottom: 10px;
  }
  .course-item-desc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
    .duration {
      display: flex;
      align-items: center;
      background: #e8e8e8;
      color: #323232;
      font-size: 24px;
      border-radius: 80px;
      padding: 4px 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .time {
      width: fit-content;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 80px;
      background: #e8e8e8;
      color: #323232;
      font-size: 24px;
      padding: 0 20px;
      max-width: 268px;
      flex: none;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
.unlock-success {
  .van-dialog__message {
    font-size: 32px;
  }
}
</style>
